import styles from './OCRScopeJobDetailBodyTitle.module.css'

export interface OCRScopeJobDetailBodyTitleProps {
  title: string
}
export function OCRScopeJobDetailBodyTitle({
  title,
}: OCRScopeJobDetailBodyTitleProps) {
  return <div className={styles.root}>{title}</div>
}
